module.exports = __webpack_public_path__ + "static/card-incidences-4a2e9568c066c55fee43f192c33e70ab.png";